class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
     window.checkProdutEligibilty();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }


     
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}





window.checkProdutEligibilty = function () {
  
    var Zepbound_ID = [8879305687352];
    var Mounjaro_ID = [8843760206136];
    var Wegovy_ID = [8843741397304];
    var Ozempic_ID = [8843766104376];
    var Tirzepatide_ID = [8843770659128];
    var Semaglutide_ID = [8843778720056];
    var Bacterial_ID = [9502219993400];
    var Uti_ID = [9502221730104];
    var Yeast_ID = [9502222713144];
    var PeriodDelay_ID = [9502223171896];
    var OralHerpes_ID = [9502228906296];
    var GenitalHerpes_ID = [9502224843064];
    var Acne_ID = [9502231331128];
    var Wrinkles_ID = [9502232281400];
    var Melasma_ID = [9502233428280];
    var Hyperhidrosis_ID = [9502234542392];
    var HairLoss_ID = [9502235689272];
    var Lashes_ID = [9502243455288];
    var Dandruff_ID = [9502238769464];
    var Maintenance_ID = [9502305943864];
    var BioBoost_ID = [9149686284600];
    var Cyanocobalamin_ID = [9494433464632];
    var Odan_ID = [9085504946488];
    var EmergencyContra_ID = [9502229758264];
  
  
    window.Zepbound_found = false;
    window.Tirzepatide_found = false;
    window.Semaglutide_found = false;
    window.Mounjaro_found = false;
    window.Wegovy_found = false;
    window.Ozempic_found = false;
    window.Bacterial_found = false;
    window.Uti_found = false;
    window.Yeast_found = false;
    window.PeriodDelay_found = false;
    window.OralHerpes_found = false;
    window.GenitalHerpes_found = false;
    window.Contraception_found = false;
    window.Acne_found = false;
    window.Wrinkles_found = false;
    window.Melasma_found = false;
    window.Hyperhidrosis_found = false;
    window.HairLoss_found = false;
    window.Lashes_found = false;
    window.Dandruff_found = false;
    window.Maintenance_found = false;
    window.BioBoost_found = false;
    window.Cyanocobalamin_found = false;
    window.Odan_found = false;
    window.EmergencyContra_found = false;
  

  
    fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      data.items.forEach((ele) => {

        let ZepboundredirectExecuted = false;
        if(Zepbound_ID.includes(ele.product_id) && !localStorage.getItem('ZepboundredirectExecuted')){
            Zepbound_found = true;
            localStorage.setItem('ZepboundredirectExecuted', 'true'); 
            location.href = "/pages/how-it-works-for-weight-loss-insurance";
        }

         let TirzepatideredirectExecuted = false;
          if(Tirzepatide_ID.includes(ele.product_id) && !localStorage.getItem('TirzepatideredirectExecuted')){
              Tirzepatide_found = true;
              localStorage.setItem('TirzepatideredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-for-weight-loss-compound-option";
          }

        let SemaglutideredirectExecuted = false;
          if(Semaglutide_ID.includes(ele.product_id) && !localStorage.getItem('SemaglutideredirectExecuted')){
              Semaglutide_found = true;
              localStorage.setItem('SemaglutideredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-for-weight-loss-compound-option";
          }

        let MounjaroredirectExecuted = false;
          if(Mounjaro_ID.includes(ele.product_id) && !localStorage.getItem('MounjaroredirectExecuted')){
              Mounjaro_found = true;
              localStorage.setItem('MounjaroredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-for-weight-loss-insurance";
          }

        let WegovyredirectExecuted = false;
          if(Wegovy_ID.includes(ele.product_id) && !localStorage.getItem('WegovyredirectExecuted')){
              Wegovy_found = true;
              localStorage.setItem('WegovyredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-for-weight-loss-insurance";
          }

        let OzempicredirectExecuted = false;
          if(Ozempic_ID.includes(ele.product_id) && !localStorage.getItem('OzempicredirectExecuted')){
              Ozempic_found = true;
              localStorage.setItem('OzempicredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-for-weight-loss-insurance";
          }

          let BacterialredirectExecuted = false;
            if(Bacterial_ID.includes(ele.product_id) && !localStorage.getItem('BacterialredirectExecuted')){
                Bacterial_found = true;
                localStorage.setItem('BacterialredirectExecuted', 'true'); 
                location.href = "/pages/how-it-works-general";
            }

         let UtiredirectExecuted = false;
          if(Uti_ID.includes(ele.product_id) && !localStorage.getItem('UtiredirectExecuted')){
              Uti_found = true;
              localStorage.setItem('UtiredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let YeastredirectExecuted = false;
          if(Yeast_ID.includes(ele.product_id) && !localStorage.getItem('YeastredirectExecuted')){
              Yeast_found = true;
              localStorage.setItem('YeastredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let PeriodDelayredirectExecuted = false;
          if(PeriodDelay_ID.includes(ele.product_id) && !localStorage.getItem('PeriodDelayredirectExecuted')){
              PeriodDelay_found = true;
              localStorage.setItem('PeriodDelayredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let OralHerpesredirectExecuted = false;
          if(OralHerpes_ID.includes(ele.product_id) && !localStorage.getItem('OralHerpesredirectExecuted')){
              OralHerpes_found = true;
              localStorage.setItem('OralHerpesredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let GenitalHerpesredirectExecuted = false;
          if(GenitalHerpes_ID.includes(ele.product_id) && !localStorage.getItem('GenitalHerpesredirectExecuted')){
              GenitalHerpes_found = true;
              localStorage.setItem('GenitalHerpesredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let AcneredirectExecuted = false;
          if(Acne_ID.includes(ele.product_id) && !localStorage.getItem('AcneredirectExecuted')){
              Acne_found = true;
              localStorage.setItem('AcneredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let WrinklesredirectExecuted = false;
          if(Wrinkles_ID.includes(ele.product_id) && !localStorage.getItem('WrinklesredirectExecuted')){
              Wrinkles_found = true;
              localStorage.setItem('WrinklesredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let MelasmaredirectExecuted = false;
          if(Melasma_ID.includes(ele.product_id) && !localStorage.getItem('MelasmaredirectExecuted')){
              Melasma_found = true;
              localStorage.setItem('MelasmaredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let HyperhidrosisredirectExecuted = false;
          if(Hyperhidrosis_ID.includes(ele.product_id) && !localStorage.getItem('HyperhidrosisredirectExecuted')){
              Hyperhidrosis_found = true;
              localStorage.setItem('HyperhidrosisredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let HairLossredirectExecuted = false;
          if(HairLoss_ID.includes(ele.product_id) && !localStorage.getItem('HairLossredirectExecuted')){
              HairLoss_found = true;
              localStorage.setItem('HairLossredirectExecuted', 'true');  
              location.href = "/pages/how-it-works-general";
          }

         let LashesredirectExecuted = false;
          if(Lashes_ID.includes(ele.product_id) && !localStorage.getItem('LashesredirectExecuted')){
              Lashes_found = true;
              localStorage.setItem('LashesredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let DandruffredirectExecuted = false;
          if(Dandruff_ID.includes(ele.product_id) && !localStorage.getItem('DandruffredirectExecuted')){
              Dandruff_found = true;
              localStorage.setItem('DandruffredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let MaintenanceredirectExecuted = false;
          if(Maintenance_ID.includes(ele.product_id) && !localStorage.getItem('MaintenanceredirectExecuted')){
              Maintenance_found = true;
              localStorage.setItem('MaintenanceredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let BioBoostredirectExecuted = false;
          if(BioBoost_ID.includes(ele.product_id) && !localStorage.getItem('BioBoostredirectExecuted')){
              BioBoost_found = true;
              localStorage.setItem('BioBoostredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let CyanocobalaminredirectExecuted = false;
          if(Cyanocobalamin_ID.includes(ele.product_id) && !localStorage.getItem('CyanocobalaminredirectExecuted')){
              Cyanocobalamin_found = true;
              localStorage.setItem('CyanocobalaminredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let OdanredirectExecuted = false;
          if(Odan_ID.includes(ele.product_id) && !localStorage.getItem('OdanredirectExecuted')){
              Odan_found = true;
              localStorage.setItem('OdanredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

         let EmergencyContraredirectExecuted = false;
          if(EmergencyContra_ID.includes(ele.product_id) && !localStorage.getItem('EmergencyContraredirectExecuted')){
              EmergencyContra_found = true;
              localStorage.setItem('EmergencyContraredirectExecuted', 'true'); 
              location.href = "/pages/how-it-works-general";
          }

        
   
      })

    });

}



customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
